import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-outline-icon',
  imports: [],
  templateUrl: './calendar-outline-icon.component.html',
  standalone: true
})
export class CalendarOutlineIconComponent {}
